import { Persistent, BasicKeys } from '@/utils/cache/persistent'
import { GUIDE_KEY, TOKEN_KEY } from '@/enums/cache'

const isLocal = false

export function getToken(): string {
  return sessionStorage.getItem(TOKEN_KEY) || ''
}

export function getShowGuide(): boolean {
  return getAuthCache(GUIDE_KEY)
}

export function getAuthCache<T>(key: BasicKeys) {
  const fn = isLocal ? Persistent.getLocal : Persistent.getSession
  return fn(key) as T
}

export function setAuthCache(key: BasicKeys, value: any) {
  const fn = isLocal ? Persistent.setLocal : Persistent.setSession
  return fn(key, value, true)
}

export function clearAuthCache(immediate = true) {
  const fn = isLocal ? Persistent.clearLocal : Persistent.clearSession
  return fn(immediate)
}
